import store from '../store/store';

/**
 * Util to get attendee's entrypoint to access dashboard.
 */
export default function getEntryPoint(): string {
    return store.entryPoint;
}
